'use client';

import { useEffect, useRef } from 'react';

import { toast } from '@/vibes/soul/primitives/toaster';
import { type ServerToastData } from '~/lib/server-toast';

export const CookieNotifications = () => {
  const lastRenderedId = useRef<number | null>(null);

  useEffect(() => {
    let isCancelled = false;

    const loadNotification = async () => {
      try {
        const response = await fetch('/api/toast-notification/', {
          cache: 'no-store',
          credentials: 'same-origin',
        });

        if (!response.ok) {
          return;
        }

        const notification = (await response.json()) as ServerToastData | null;

        if (!notification || isCancelled || notification.id === lastRenderedId.current) {
          return;
        }

        const { message, variant, position, description } = notification;

        toast[variant](message, { position, description });
        lastRenderedId.current = notification.id;
      } catch (error) {
        console.error('Failed to load toast notification', error);
      }
    };

    void loadNotification();

    return () => {
      isCancelled = true;
    };
  }, []);

  return null;
};
